import { Flex, Box, Button, useColorMode } from "@chakra-ui/react";
import { useState } from "react";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";
import LoadableContent from "src/components/LoadableContent";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import SvgContainer from "src/components/SvgContainer";
import NavigationButtons from "src/components/NavigationButtons";
import { H3, BodyText2, Overline } from "src/atoms/typography";

import { ReactComponent as ArrowDown } from "../arrow-down.svg";
import { ReactComponent as SelectedIcon } from "src/icons/selected.svg";

export default function Cards({
  handleAvatarChange,
  StationSelect,
  handleConnect,
  selectedStations,
  listedStations,
  isConnecting,
  isInModal,
  avatars,
  refs,
  t
}) {
  const [oppenedMenuIndex, setOpennedMenuIndex] = useState(null);
  const { colorMode } = useColorMode();
  const isDarkMode = colorMode === "dark";
  const stationsToConnect = listedStations?.filter((station) =>
    selectedStations?.includes(station.jid)
  );
  return (
    <>
      {!isConnecting && !isInModal && (
        <NavigationButtons
          mode="fullScreen"
          onBack={({ navigate }) => navigate("/dashboard")}
        />
      )}
      <Flex
        pt="48px"
        onClick={() => setOpennedMenuIndex(null)}
        width="100%"
        alignItems="center"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <Box>
          <Overline
            fontSize={["1.2rem", "1.6rem", "1.8rem"]}
            mb={["16px", "22px", "25px"]}
            textAlign="center"
            color="mediumEmphasis"
          >
            {`${t("parentStation.stationSelect.heading")}:`.toUpperCase()}
          </Overline>
          <Flex
            justifyContent="center"
            ml={isInModal ? "0px" : "68px"}
            mr={
              isInModal ? "0px" : listedStations?.length > 4 ? "60px" : "68px"
            }
            {...(listedStations?.length > 4 && {
              maxHeight: "55vh",
              overflowY: "auto"
            })}
          >
            <Flex
              flexWrap="wrap"
              gap="16px"
              width={["544px", "756px", "860px"]}
            >
              {listedStations?.map((station, i) => {
                const selectedAvatar = avatars.filter(
                  (avatar) => avatar.objectId === station.avatarId
                )[0];
                const isSelected = selectedStations.includes(station.jid);
                const isOpenned = oppenedMenuIndex === i;
                return (
                  <Flex
                    key={i}
                    onClick={(e) => {
                      isSelected
                        ? StationSelect.remove(station.jid)
                        : StationSelect.add(station.jid);
                    }}
                    bg={isInModal ? "surfaceElevated2" : "surfaceElevated1"}
                    alignItems="center"
                    width={["264px", "370px", "422px"]}
                    pr={["8px", "11px", "13px"]}
                    pl={["24px", "33px", "38px"]}
                    py={["24px", "33px", "38px"]}
                    position="relative"
                    borderRadius="12px"
                    boxShadow="0 2px 4px 0 rgba(0, 0, 0, 0.12),0 1px 16px 0 rgba(0, 0, 0, 0.06),0 4px 8px 0 rgba(0, 0, 0, 0.08)"
                    transition="background-color 0.3s"
                    _hover={{
                      bg: isDarkMode
                        ? isInModal
                          ? "surfaceElevated3"
                          : "surfaceElevated2"
                        : "primaryLight"
                    }}
                  >
                    <Box
                      minWidth={["65px", "91px", "104px"]}
                      minHeight={["65px", "91px", "104px"]}
                      maxWidth={["65px", "91px", "104px"]}
                      maxHeight={["65px", "91px", "104px"]}
                    >
                      <CorrespondingAvatar
                        width={[
                          "65px !important",
                          "91px !important",
                          "104px !important"
                        ]}
                        height={[
                          "65px !important",
                          "91px !important",
                          "104px !important"
                        ]}
                        avatar={selectedAvatar}
                      />
                    </Box>
                    <Box ml="20px">
                      <H3
                        ml="4px"
                        color="highEmphasis"
                        maxWidth={["150px", "270px", "320px"]}
                        fontSize={["1.6rem", "2rem", "2.2rem"]}
                        display="-webkit-box"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        sx={{
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical"
                        }}
                      >
                        {station.name}
                      </H3>
                      {selectedAvatar && (
                        <Menu
                          isOpen={isOpenned}
                          onClose={(e) => {
                            e.stopPropagation();
                          }}
                          contentProps={{
                            overflowY: "scroll",
                            maxHeight: "180px"
                          }}
                          // anchorOrigin={{
                          //   vertical: "top",
                          //   horizontal: "center"
                          // }}
                          // transformOrigin={{
                          //   vertical: "top",
                          //   horizontal: "center"
                          // }}
                          anchorEl={
                            <Flex
                              px="4px"
                              ref={(el) => (refs.current[i] = el)}
                              alignItems="center"
                              onClickCapture={(e) => {
                                if (oppenedMenuIndex === i)
                                  setOpennedMenuIndex(null);
                                else setOpennedMenuIndex(i);
                                e.stopPropagation();
                              }}
                              width="max-content"
                              transition="background-color 0.3s"
                              borderRadius="8px"
                              _hover={{
                                bg: "iconBackground"
                              }}
                            >
                              <BodyText2
                                color="mediumEmphasis"
                                textOverflow="ellipsis"
                                overflow="hidden"
                                whiteSpace="nowrap"
                                maxWidth={["100px", "220px", "270px"]}
                                fontSize={["1.2rem", "1.6rem", "1.8rem"]}
                              >
                                {selectedAvatar?.name}
                              </BodyText2>
                              <SvgContainer
                                ml="4px"
                                icon={ArrowDown}
                                size="16px"
                                fill="mediumEmphasis"
                                width={["16px", "22px", "24px"]}
                                height={["16px", "22px", "24px"]}
                              />
                            </Flex>
                          }
                        >
                          {avatars?.map((avatar) => (
                            <MenuItem
                              key={avatar.objectId}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAvatarChange(i, avatar.objectId);
                                setOpennedMenuIndex(null);
                              }}
                            >
                              <Box mr="16px">
                                <CorrespondingAvatar
                                  avatar={avatar}
                                  width="24px"
                                  height="24px"
                                />
                              </Box>
                              <MenuItemText>{avatar.name}</MenuItemText>
                            </MenuItem>
                          ))}
                        </Menu>
                      )}
                    </Box>
                    <Flex
                      alignItems="center"
                      justifyContent="center"
                      width="14px"
                      bg={
                        isConnecting
                          ? "outline"
                          : isSelected
                            ? "primary"
                            : "transparent"
                      }
                      borderRadius="100%"
                      position="absolute"
                      bottom="8px"
                      right="8px"
                      height={["24px", "34px", "38px"]}
                      minWidth={["24px", "34px", "38px"]}
                      {...(!isSelected && {
                        border: "solid 1px",
                        borderColor: "outline"
                      })}
                    >
                      {isSelected && (
                        <SvgContainer
                          icon={SelectedIcon}
                          height={["16px", "20px", "22px"]}
                          width={["16px", "20px", "22px"]}
                          fill={
                            isConnecting
                              ? isInModal
                                ? "surfaceElevated3"
                                : "surfaceElevated2"
                              : "white"
                          }
                        />
                      )}
                    </Flex>
                  </Flex>
                );
              })}
            </Flex>
          </Flex>
        </Box>
        <LoadableContent width="auto" showContent={!isConnecting}>
          <Button
            variant="containedPrimary"
            disabled={!selectedStations || selectedStations.length === 0}
            onClick={() => handleConnect(stationsToConnect)}
            fontSize={["1.2rem", "1.7rem", "1.8rem"]}
            px={["24px", "40px", "46px"]}
            py={["11px", "17px", "19px"]}
            mb={["16px", "24px", "32px"]}
            borderRadius={["18px", "28px", "36px"]}
          >
            {t("buttons.connect")}
          </Button>
        </LoadableContent>
      </Flex>
    </>
  );
}
